import { render, staticRenderFns } from "./BaseTopBar.vue?vue&type=template&id=22a9bf9e"
import script from "./BaseTopBar.vue?vue&type=script&lang=js"
export * from "./BaseTopBar.vue?vue&type=script&lang=js"
import style0 from "./BaseTopBar.vue?vue&type=style&index=0&id=22a9bf9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports